import { render } from "./StaticNotionView.vue?vue&type=template&id=c45d7548"
import script from "./StaticNotionView.vue?vue&type=script&lang=js"
export * from "./StaticNotionView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__